// src/components/WallpaperPicker.js
import { useMemo } from "react";
import "./WallpaperPicker.css";

function loadWallpapersFromFolder() {
  // loads: src/assets/wallpapers/*.(png|jpg|jpeg|svg|webp)
  const req = require.context("../../assets/wallpapers", false, /\.(png|jpe?g|svg|webp)$/i);

  return req
    .keys()
    .map((p) => {
      const mod = req(p);
      const src = mod?.default ?? mod;
      const filename = p.replace("./", "");
      const key = filename.replace(/\.[^.]+$/, ""); // strip extension
      return { key, src, filename };
    })
    .sort((a, b) => a.key.localeCompare(b.key));
}

export default function WallpaperPicker({ value = "", onChange }) {
  const wallpapers = useMemo(() => loadWallpapersFromFolder(), []);

  return (
    <div className="wallpaper-picker">
      <div className="wallpaper-header">
        <div>
          <div className="wallpaper-title">Choose wallpaper</div>
          <div className="wallpaper-subtitle muted">Tap a wallpaper to select</div>
        </div>
      </div>

      <div className="wallpaper-grid">
        {wallpapers.map((w) => {
          const isSelected = w.key === value;

          return (
            <button
              key={w.key}
              type="button"
              className={`wallpaper-tile ${isSelected ? "is-selected" : ""}`}
              onClick={() => onChange?.(w.key)}
              title={w.key}
              aria-pressed={isSelected}
            >
              <img className="wallpaper-img" src={w.src} alt={w.key} />
            </button>
          );
        })}
      </div>
    </div>
  );
}